import {observer} from "mobx-react";
import {useServices} from "../../../react-hooks/use-services.hook";
import {AccordionComponent} from "../../accordion/accordion.component";
import {OptInJackpotBetDialogBox} from "./boxes/opt-in-jackpot-bet-dialog/opt-in-jackpot-bet-dialog.box";
import {OptInTextContentBox} from "./boxes/content/opt-in-text-content/opt-in-text-content.box";
import {OptInTextTitleBox} from "./boxes/content/opt-in-text-title/opt-in-text-title.box";
import {OptInAccordionContentComponent} from "./components/opt-in-accordion-content/opt-in-accordion-content.component";
import {OptInDialogHeaderComponent} from "./components/opt-in-dialog-header/opt-in-dialog-header.component";
import {OptInAccordionTitleComponent} from "./accordion-title/opt-in-accordion-title.component";
import {OptInDialogFooterBox} from "./boxes/footer/opt-in-dialog-footer.box";
import {OptInDialogFooterButtonBox} from "./boxes/footer/opt-in-dialog-footer-button.box";

export interface IOptInJackpotBetDialogOptions {
    optIn(): void;
    optOut(): void;
}
export const JackpotBetsOptInDialogComponent: React.FC<IOptInJackpotBetDialogOptions> = observer((props) => {
    const services = useServices();

    return (
        <OptInJackpotBetDialogBox>
            <OptInDialogHeaderComponent />
            <OptInTextTitleBox>
                {services.translation.translate('JACKPOT_BET_OPT_IN_WELCOME')}
            </OptInTextTitleBox>
            <OptInTextContentBox>
                {services.translation.translate('JACKPOT_BET_OPT_IN_DETAILS', {
                    jackpotBetContribution: services.currency.formatMoney(services.jackpotBet.participationFee, true)
                })}
            </OptInTextContentBox>
            <AccordionComponent
                title={<OptInAccordionTitleComponent />}
                content={<OptInAccordionContentComponent />}
                isTitleCentered={true}
                onExpandChange={(isExpanded: boolean) => {
                    services.jackpotBet.sendJackpotBetEvent('opt_in_popup_rules_expand',
                        ``, `expanding:${isExpanded}`);
                }}
            />

            <OptInDialogFooterBox>
                <OptInDialogFooterButtonBox
                    preset="primary"
                    fullWidth
                    className={'cy-opt-in-jackpot-bet-button'}
                    onClick={props.optIn}>
                    {services.translation.translate('JACKPOT_BET_OPT_IN')}
                </OptInDialogFooterButtonBox>
                <OptInDialogFooterButtonBox
                    preset="secondary"
                    fullWidth
                    className={'cy-opt-out-jackpot-bet-button'}
                    onClick={props.optOut}
                >
                    {services.translation.translate('JACKPOT_BET_PLAY_WITHOUT_JACKPOT_BET')}
                </OptInDialogFooterButtonBox>
            </OptInDialogFooterBox>
        </OptInJackpotBetDialogBox>
    )
})